import { TermsAndConditionsState } from "../states/termsAndConditions";
import { ETimerActions, TimerActions } from "../actions/timer";
import {
  TermsAndConditionsActions,
  ETermsAndConditionsActions,
} from "../actions/termsAndConditions";
import { ITermsAndConditions } from "../../models/termsAndConditions";

export function TermsAndConditionsReducers(
  state: ITermsAndConditions = TermsAndConditionsState,
  action: TermsAndConditionsActions,
): ITermsAndConditions {
  switch (action.type) {
    case ETermsAndConditionsActions.UpdateTermsAndConditionsCheckboxState: {
      return {
        // ...state,
        termsAndConditionsCheckboxState: action.payload,
      };
    }
    default:
      return state;
  }
}
